<template>
  <div class="orders" data-intro="История заявок">
    <v-layout column>
      <v-flex xs12>
        <h1>Заявки</h1>
      </v-flex>
      <v-flex xs12>
        <v-card class="elevation-3 pa-2">
          <v-btn
            v-if="isBasketExists"
            color="secondary"
            @click.stop="viewBasket"
          >
            <v-icon>{{ icons.edit }}</v-icon
            >&nbsp;Продолжить заявку
          </v-btn>
          <v-btn v-else class="ma-2" color="primary" :to="{ name: 'order' }">
            <v-icon>{{ icons.plus }}</v-icon
            >&nbsp;Добавить заявку
          </v-btn>
        </v-card>
      </v-flex>
      <v-flex xs12 class="my-2">
        <Orders :orders="orders" />
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="dialogBasket" max-width="800px">
      <v-card>
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>
            <span class="headline">Новый заказ</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="onCancelBasket">
              <v-icon>{{ icons.close }}</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <OrderEdit
            :order="this.order"
            v-on:update-quantity="updateQuantity"
          />
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" sm="6" offset-sm="1">
              <excel
                :name="excelName"
                :fields="excelOrderFields"
                :data="this.order.items"
              >
                <v-btn outlined color="primary">
                  <v-icon>{{ icons.export }}</v-icon
                  >&nbsp;Экспорт в Excel
                </v-btn>
              </excel>
            </v-col>
            <v-col cols="6" sm="2">
              <v-btn outlined color="secondary" @click="onDeleteBasket"
                >Удалить</v-btn
              >
            </v-col>
            <v-col cols="6" sm="2">
              <v-btn dark color="primary" @click="onSaveBasket"
                >Продолжить</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

const Orders = () => import("@/components/Orders/Orders");
const OrderEdit = () => import("@/components/Orders/OrderEdit");

export default {
  components: {
    Orders,
    OrderEdit,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      orders: (state) => state.orders.orders,
      basket: (state) => state.baskets.basket,
    }),
    isBasketExists: function () {
      return this.basket != null && this.basket.length > 0;
    },
    excelName: function () {
      return "order_" + this.$dayjs().format("YYYY-MM-DD_HH-mm-ss") + ".xls";
    },
    excelOrderFields: function () {
      return {
        "Адрес доставки": "pointAddress",
        Производитель: "manufacturer",
        "Группа прайса": "priceGroup",
        Наименование: "productName",
        Страна: "productCountry",
        "Срок годности": {
          field: "expiration",
          callback: (value) => {
            return `${this.$dayjs(String(value)).format("MM-YYYY")}`;
          },
        },
        "Цена, РОЦ": {
          field: "price",
          callback: (value) => {
            return `${value.toLocaleString().replace(/\./g, ",")}`;
          },
        },
        "Количество, шт": "quantity",
      };
    },
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      getOrders: "orders/GET_ORDERS",
      createOrder: "orders/CREATE_ORDER",
      getBasket: "baskets/GET_BASKET",
      upsertBasket: "baskets/UPSERT_BASKET",
      deleteBasket: "baskets/DELETE_BASKET",
      deleteFilterOrders: "orders/DELETE_FILTER_ORDERS",
    }),
    init: function () {
      this.$store.subscribe((mutation) => {
        switch (mutation.type) {
          case "baskets/SET_BASKET":
            if (!this.basket || this.basket == null || this.basket.length <= 0)
              this.dialogBasket = false;
            break;
        }
      });
    },
    viewBasket: async function () {
      this.order = {
        number: "",
        created: "",
        items: Object.values(this.basket),
      };

      this.dialogBasket = true;
    },
    updateQuantity: async function (item) {
      await this.upsertBasket(item);

      this.order = {
        number: "",
        created: "",
        items: this.basket,
      };
    },
    onCancelBasket: function () {
      this.dialogBasket = false;
    },
    onDeleteBasket: async function () {
      await this.deleteBasket();
      this.dialogBasket = false;
    },
    onSaveBasket: async function () {
      this.dialogBasket = false;
      this.$router.push("/order");
    },
  },
  data: () => ({
    icons: {
      plus: Icon.plus,
      edit: Icon.edit,
      close: Icon.close,
      export: Icon.export,
    },
    dialogBasket: false,
    order: {},
  }),
  mounted: async function () {
    await this.getUser(this.user.userId);
    await this.getOrders();
    await this.getBasket();

    this.init();
  },
  beforeRouteEnter(to, from, next) {
    if (from.name != "order") {
      next((c) => {
        c.deleteFilterOrders();
      });
    } else {
      next();
    }
  },
};
</script>
